<template>
  <div>
    <div class="font-normal" v-if="typeWireTransfer">
      <div class="-mt-10 dialog-header">
        <div class="">
          <div class="flex w-full items-center">
            <div
              v-if="currentDepositTypeView === 'depositType'"
              @click="goBack"
              class="cursor-pointer"
            >
              <i class="el-icon-arrow-left"></i>
            </div>
            <div
              class="text-lg md:text-2xl w-full text-root-2 font-bold flex justify-center"
            >
              Bank Details
            </div>
          </div>
          <div class="w-full text-xs text-root-4 text-center font-normal">
            Wire transfer
          </div>
        </div>
        <div
          class="text-root-4 h-11 my-2 flex justify-center font-normal text-xs"
        >
          <div
            style="word-break: normal"
            class="text-center mx-14 text-13px mt-3"
            v-if="batchDetails"
          >
            You are to send exactly
            <span class="text-primary">${{ batchDetails.amount }}.</span> Please
            ensure you use the correct reference when making a deposit.
          </div>
          <div
            v-else
            class="mx-2 bg-root-yellow small-text border border-yellow-10 text-root-yellow rounded-md px-1 md:px-4 items-center flex"
            style="word-break: normal"
          >
            <warning-icon class="mr-2 md:mr-4 md:-mt-2" /> Please ensure you use
            the correct reference when making a deposit.
          </div>
        </div>
      </div>
      <div class="text-xs font-semibold text-root-4 mt-7">
        <div
          class="rounded-md shadow border-text-root-3 my-4 py-2 grid grid-cols-6 px-4"
        >
          <div class="col-span-2">Account-Number:</div>
          <div class="col-span-3 mx-2" v-if="wireTransferDetails.accountNumber">
            {{ wireTransferDetails.accountNumber }}
          </div>
          <div
            v-if="wireTransferDetails.accountNumber"
            class="justify-self-center cursor-pointer"
            v-clipboard:copy="wireTransferDetails.accountNumber"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </div>
        </div>
        <div
          class="rounded-md shadow border-text-root-3 my-4 py-2 grid grid-cols-6 px-4"
        >
          <div class="col-span-2">Bank-Phone:</div>
          <div class="col-span-3 mx-2" v-if="wireTransferDetails.bankPhone">
            {{ wireTransferDetails.bankPhone }}
          </div>
          <div
            v-if="wireTransferDetails.bankPhone"
            class="justify-self-center cursor-pointer"
            v-clipboard:copy="wireTransferDetails.bankPhone"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </div>
        </div>
        <div
          class="rounded-md shadow border-text-root-3 my-4 py-2 grid grid-cols-6 px-4"
        >
          <div class="col-span-2">Bank Address:</div>
          <div class="col-span-3 mx-2" v-if="wireTransferDetails.bankAddress">
            {{ wireTransferDetails.bankAddress }}
          </div>
          <div
            v-if="wireTransferDetails.bankAddress"
            class="justify-self-center cursor-pointer"
            v-clipboard:copy="wireTransferDetails.bankAddress"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </div>
        </div>
        <div
          class="rounded-md shadow border-text-root-3 my-4 py-2 grid grid-cols-6 px-4"
        >
          <div class="col-span-2">Beneficiary Address:</div>
          <div
            class="col-span-3 mx-2"
            v-if="wireTransferDetails.beneficiaryAddress"
          >
            {{ wireTransferDetails.beneficiaryAddress }}
          </div>
          <div
            v-if="wireTransferDetails.beneficiaryAddress"
            class="justify-self-center cursor-pointer"
            v-clipboard:copy="wireTransferDetails.beneficiaryAddress"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </div>
        </div>
        <div
          class="rounded-md shadow border-text-root-3 my-4 py-2 grid grid-cols-6 px-4"
        >
          <div class="col-span-2">Credit To:</div>
          <div class="col-span-3 mx-2" v-if="wireTransferDetails.creditTo">
            {{ wireTransferDetails.creditTo }}
          </div>
          <div
            v-if="wireTransferDetails.creditTo"
            class="justify-self-center cursor-pointer"
            v-clipboard:copy="wireTransferDetails.creditTo"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </div>
        </div>
        <div
          class="rounded-md shadow border-text-root-3 my-4 py-2 grid grid-cols-6 px-4"
        >
          <div class="col-span-2 mr-8">Depository Bank Name:</div>
          <div
            class="col-span-3 mx-2"
            v-if="wireTransferDetails.depositoryBankName"
          >
            {{ wireTransferDetails.depositoryBankName }}
          </div>
          <div
            v-if="wireTransferDetails.depositoryBankName"
            class="justify-self-center cursor-pointer"
            v-clipboard:copy="wireTransferDetails.depositoryBankName"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </div>
        </div>
        <div
          class="rounded-md shadow border-text-root-3 my-4 py-2 grid grid-cols-6 px-4"
        >
          <div class="col-span-2">Reference:</div>
          <div class="col-span-3 mx-2" v-if="wireTransferDetails.reference">
            {{ wireTransferDetails.reference }}
          </div>
          <div
            v-if="wireTransferDetails.reference"
            class="justify-self-center cursor-pointer"
            v-clipboard:copy="wireTransferDetails.reference"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </div>
        </div>
        <div
          class="rounded-md shadow border-text-root-3 my-4 py-2 grid grid-cols-6 px-4"
        >
          <div class="col-span-2">Routing-Number:</div>
          <div class="col-span-3 mx-2" v-if="wireTransferDetails.routingNumber">
            {{ wireTransferDetails.routingNumber }}
          </div>
          <div
            v-if="wireTransferDetails.routingNumber"
            class="justify-self-center cursor-pointer"
            v-clipboard:copy="wireTransferDetails.routingNumber"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </div>
        </div>
        <div
          class="rounded-md shadow border-text-root-3 my-4 py-2 grid grid-cols-6 px-4"
        >
          <div class="col-span-2">Swift-Code</div>
          <div class="col-span-3 mx-2" v-if="wireTransferDetails.swiftCode">
            {{ wireTransferDetails.swiftCode }}
          </div>
          <div
            v-if="wireTransferDetails.swiftCode"
            class="justify-self-center cursor-pointer"
            v-clipboard:copy="wireTransferDetails.swiftCode"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </div>
        </div>
      </div>
      <div class="flex justify-center gap-2 md:gap-3 items-center mt-8">
        <div
          class="w-48 font-semibold hover:opacity-80 bg-root border-primary rounded-full border flex justify-center py-3 cursor-pointer text-primary"
          @click="generatePdf"
        >
          Download
        </div>
        <div
          @click="completedDeposit"
          class="bg-primary cursor-pointer font-semibold hover:opacity-80 text-white py-3 w-48 rounded-full"
        >
          <div class="flex justify-center">Done</div>
        </div>
      </div>
      <vuehtml2pdf
        :manual-pagination="true"
        :filename="fileName"
        :pdf-quality="2"
        pdf-format="a4"
        pdf-content-width="800px"
        :enable-download="true"
        ref="DownloadComp"
        :show-layout="false"
      >
        <section slot="pdf-content">
          <deposit-details />
        </section>
      </vuehtml2pdf>
    </div>
    <div v-else>
      <wire-transfer-details
        @closeDialog="handleClose"
        :transferType="transferType"
      />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      wireTransferDetails: null,
      transferType: 'treasury'
    }
  },
  props: {
    batchDetails: Object
  },
  methods: {
    generatePdf () {
      this.$refs.DownloadComp.generatePdf()
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    goBack () {
      if (this.currentTypeView === 'depositType') {
        this.$emit('goBack')
        this.$emit('closeDialog')
      } else {
        this.$emit('goBackToPendingDialog')
      }
    },
    completedDeposit () {
      if (this.batchDetails) {
        this.$router.push('/api-management')
        this.$store.dispatch('externalApi/setActiveComponent', 'Settlements')
      }
      this.$store.dispatch('transactions/wireTransferType', null)
      if (this.currentTypeView === 'depositType') {
        this.$emit('completedDeposit')
      } else {
        this.$emit('closeDialog')
      }
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    DepositDetails: () => import('@/components/deposit/DepositDetails.vue'),
    WarningIcon: () => import('@/assets/icons/WarningIcon.vue'),
    wireTransferDetails: () =>
      import('@/components/deposit/WireTransferDetails.vue')
  },
  computed: {
    fileName () {
      return `${process.env.VUE_APP_TENANT_TITLE} Deposit Details`
    },
    typeWireTransfer () {
      return (
        this.wireTransferType === 'Within The United States' ||
        this.wireTransferType === 'International Transfer'
      )
    },
    currentDepositTypeView () {
      return this.$store.state.transactions.depositTypeView
    },
    wireTransferType () {
      return this.$store.state.transactions.wireTransferType
    },
    localTransfer () {
      const details = this.$store.state.transactions.depositInfo.wireInstruction
      return details || {}
    },
    internationalTransfer () {
      const details =
        this.$store.state.transactions.depositInfo.wireInstructionIntl
      return details || {}
    },
    business () {
      return this.$store.state.auth.business
    }
  },
  beforeMount () {
    if (this.wireTransferType === 'Within The United States') {
      this.wireTransferDetails = this.localTransfer
    } else if (this.wireTransferType === 'International Transfer') {
      this.wireTransferDetails = this.internationalTransfer
    }
  }
}
</script>

<style scoped>
>>> .el-button.is-disabled {
  background-color: #f4a177;
  color: white;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
.small-text {
  font-size: 10px;
}
</style>
